import React, { useEffect, useState } from 'react'
import voucherPaymentItemServices from '../voucherPaymentItemServices';
import { Link } from 'react-router-dom';

function InvoiceSettlementList({voucherDetails}) {

    const [loading,setLoadingStatus] = useState(false);
    const [invoiceSettlementList,setInvoiceSettlementList] = useState(null);

    const getVoucherSettlementList = () =>{
        setLoadingStatus(true);
        voucherPaymentItemServices.getInvoiceSettlementList(voucherDetails.id).then(res=>{
            setInvoiceSettlementList(res.data);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getVoucherSettlementList();
    },[voucherDetails])

    return (
        invoiceSettlementList && invoiceSettlementList.length > 0 &&
        <table className='table table-sm table-striped table-bordered mb-0' style={{ fontSize: 12 }}>
            <thead className='table-dark'>
                <tr>
                    <th colSpan={2}>Payment Details</th>
                </tr>
            </thead>
            <tbody>
                <tr className='table-info'>
                    <th>Voucher #</th>
                    <th>Amount</th>
                </tr>
                {invoiceSettlementList.map(payment =>
                    <tr key={payment.id}>
                        <td><Link to={"/voucher/payment-receipt/details/"+payment.id}> {payment.voucherNo}</Link></td>
                        <td>{payment.amount}</td>
                    </tr>
                )}
                <tr></tr>
            </tbody>
        </table>
    )
}

export default InvoiceSettlementList